import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, LayoutIcon, CodeIcon, SmartphoneIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLid3Page: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2106">
      <SEO data-id="element-2107" />
      <Header data-id="element-2108" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2109">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2110">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2111">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2112" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2113">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2114">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg" data-id="element-2115">
                <img src="https://cdn.magicpatterns.com/uploads/5ccyafcfpYqxWEyuCGARef/Mogelijk_voor_website_(19).jpg" alt="Alex" className="w-full h-full object-cover" data-id="element-2116" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2117">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2118">
                Naam 3
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2119">
                Webdesigner & Developer
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2120">
                <p className="mb-4" data-id="element-2121">
                  Als Webdesigner en Developer sla ik de brug tussen esthetiek
                  en functionaliteit. Ik vertaal de strategische visie van
                  CorePrint naar snelle, gebruiksvriendelijke en
                  conversiegerichte websites die perfect passen bij de
                  merkidentiteit van onze klanten.
                </p>
                <p className="mb-4" data-id="element-2122">
                  Mijn focus ligt op het creëren van naadloze
                  gebruikerservaringen (UX) en strakke interfaces (UI). Een
                  website moet er niet alleen fantastisch uitzien, maar ook
                  intuïtief werken op elk apparaat en razendsnel laden.
                </p>
                <p data-id="element-2123">
                  Ik bouw robuuste, schaalbare oplossingen in WordPress, waarbij
                  ik altijd rekening houd met de nieuwste webstandaarden,
                  toegankelijkheid en technische SEO-vereisten.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2124">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2125">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2126">
                  <LayoutIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2127" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2128">WordPress</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2129">
                  <SmartphoneIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2130" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2131">UI/UX Design</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2132">
                  <CodeIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2133" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2134">
                    Frontend Development
                  </h3>
                </div>
              </div>

              <button onClick={() => navigate('/')} className="bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2135">
                Neem contact op met Alex
              </button>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2136" />
    </div>;
};